import React, { useCallback, useState } from "react";

const Procedure = (props) => {
  const [data, setData] = useState(props.getData());
  const [currentIdx, setcurrentIdx] = useState("");
  const [searchText, setSearchText] = useState("");
  const handleChange = useCallback(
    (e) => {
      setSearchText(e.target.value);
      setcurrentIdx("");
      const originalData = props.getData();
      const filteredData = originalData.objects.filter((item) =>
        item.resource.code.text
          .trim()
          .toLowerCase()
          .includes(e.target.value.trim().toLowerCase())
      );
      setData({ objects: filteredData });
    },
    [props]
  );
  return (
    <div className="observationContainerResource">
      <div className="search">
        <input
          type="text"
          value={searchText}
          onChange={handleChange}
          className="searchBox"
          placeholder="Search..."
        />
      </div>
      {data?.objects?.map((item, idx) => (
        <div
          className={`observationItem ${
            currentIdx === idx ? "active" : ""
          } cursor-pointer`}
          key={idx}
          onClick={() => {
            props.setResourceListData(item);
            setcurrentIdx(idx);
          }}
        >
          <span
            className={`${
              idx === data?.objects?.length - 1 ? "lastRow" : ""
            } observationText`}
          >
            {item?.resource?.code?.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default Procedure;
